import { cloneDeep } from "lodash";
import { consentUtil } from "../../utils";

const SET_CONSENTS = "app/consents/SET_CONSENTS";
const RESET_CONSENTS = "app/consents/RESET_CONSENTS";
const SET_SELECTED_CONSENT = "app/consents/SET_SELECTED_CONSENT";
const SET_CONSENT_ELEMENTS = "app/consents/SET_CONSENT_ELEMENTS";
const INSERT_CONSENT_ELEMENT = "app/consents/INSERT_CONSENT_ELEMENT";
const ALIGN_CONSENT_ELEMENT_TEXTS = "app/consents/ALIGN_CONSENT_ELEMENT_TEXTS";
const RESET_CONSENT_ELEMENTS = "app/consents/RESET_CONSENT_ELEMENTS";
const SET_SELECTED_CONSENT_ELEMENT = "app/consents/SET_SELECTED_CONSENT_ELEMENT";
const SET_CONSENT_ELEMENTS_VISIBILITY = "app/consents/SET_CONSENT_ELEMENTS_VISIBILITY";
const SET_MARKET = "app/consents/SET_MARKET";
const SET_APP_TYPE = "app/consents/SET_APP_TYPE";
const SET_IS_DUPLICATE = "app/consents/SET_IS_DUPLICATE";
const SET_IS_VIEW_ONLY = "app/consents/SET_IS_VIEW_ONLY";
const SET_LOADING = "app/consents/SET_LOADING";
const SET_REFRESH = "app/consents/SET_REFRESH";
const SET_CONSENTS_ERROR = "app/consents/SET_CONSENTS_ERROR";
const SET_CONSENT_ELEMENTS_ERROR = "app/consents/SET_CONSENT_ELEMENTS_ERROR";
const SET_DUPLICATE_CONSENT_ID = "app/consents/SET_DUPLICATE_CONSENT_ID";

const initialState = {
  consents: null,
  selectedConsent: null,
  consentElements: [],
  consentElementsVisibility: null,
  selectedConsentElement: null,
  market: null,
  // TODO: update when app selector will be implemented
  appType: "REMOTE_CARE",
  isDuplicate: false,
  duplicateConsentId: null,
  isViewOnly: false,
  loading: false,
  refresh: false,
  errors: {
    consents: null,
    consentElements: null
  }
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_CONSENTS: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        consents: action.payload
      };
    }

    case RESET_CONSENTS: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        consents: null
      };
    }

    case SET_SELECTED_CONSENT: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        selectedConsent: action.payload
      };
    }

    case SET_CONSENT_ELEMENTS: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        consentElements: action.payload
      };
    }

    case INSERT_CONSENT_ELEMENT: {
      const clonedState = cloneDeep(state);

      const insertedConsentElement = action.payload;
      const idx = clonedState.consentElements?.findIndex(
        (consentElement) => consentElement.id === insertedConsentElement?.id
      );

      let newConsentElements;

      if (idx !== -1) {
        newConsentElements = [
          ...clonedState.consentElements.slice(0, idx),
          insertedConsentElement,
          ...clonedState.consentElements.slice(idx + 1)
        ];
      } else {
        newConsentElements = [...clonedState.consentElements, insertedConsentElement];
      }

      return {
        ...clonedState,
        consentElements: newConsentElements
      };
    }

    case ALIGN_CONSENT_ELEMENT_TEXTS: {
      const clonedState = cloneDeep(state);
      const baseConsentElement = action.payload;

      const newConsentElements = consentUtil.alignConsentElementTexts(
        baseConsentElement,
        clonedState.consentElements
      );

      return {
        ...clonedState,
        consentElements: newConsentElements
      };
    }

    case RESET_CONSENT_ELEMENTS: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        consentElements: [],
        consentElementsVisibility: null
      };
    }

    case SET_SELECTED_CONSENT_ELEMENT: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        selectedConsentElement: action.payload
      };
    }

    case SET_CONSENT_ELEMENTS_VISIBILITY: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        consentElementsVisibility: action.payload
      };
    }

    case SET_MARKET: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        market: action.payload
      };
    }

    case SET_APP_TYPE: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        appType: action.payload
      };
    }

    case SET_IS_DUPLICATE: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        isDuplicate: action.payload
      };
    }

    case SET_IS_VIEW_ONLY: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        isViewOnly: action.payload
      };
    }

    case SET_LOADING: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        loading: action.payload
      };
    }

    case SET_REFRESH: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        refresh: action.payload
      };
    }

    case SET_CONSENTS_ERROR: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        errors: {
          ...clonedState.errors,
          consents: action.payload
        }
      };
    }

    case SET_CONSENT_ELEMENTS_ERROR: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        errors: {
          ...clonedState.errors,
          consentElements: action.payload
        }
      };
    }

    case SET_DUPLICATE_CONSENT_ID: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        duplicateConsentId: action.payload
      };
    }

    default: {
      return state;
    }
  }
}

export const setConsents = (consents) => ({ type: SET_CONSENTS, payload: consents });

export const resetConsents = () => ({ type: RESET_CONSENTS });

export const setSelectedConsent = (selectedConsent) => ({
  type: SET_SELECTED_CONSENT,
  payload: selectedConsent
});

export const setConsentElements = (consentElements) => ({
  type: SET_CONSENT_ELEMENTS,
  payload: consentElements
});

export const insertConsentElement = (consentElement) => ({
  type: INSERT_CONSENT_ELEMENT,
  payload: consentElement
});

export const alignConsentElementTexts = (consentElement) => ({
  type: ALIGN_CONSENT_ELEMENT_TEXTS,
  payload: consentElement
});

export const resetConsentElements = () => ({
  type: RESET_CONSENT_ELEMENTS
});

export const setSelectedConsentElement = (selectedConsentElement) => ({
  type: SET_SELECTED_CONSENT_ELEMENT,
  payload: selectedConsentElement
});

export const setConsentElementsVisibility = (isVisible) => ({
  type: SET_CONSENT_ELEMENTS_VISIBILITY,
  payload: isVisible
});

export const setMarket = (market) => ({ type: SET_MARKET, payload: market });

export const setAppType = (appType) => ({ type: SET_APP_TYPE, payload: appType });

export const setIsDuplicate = (isDuplicate) => ({ type: SET_IS_DUPLICATE, payload: isDuplicate });

export const setIsViewOnly = (isViewOnly) => ({ type: SET_IS_VIEW_ONLY, payload: isViewOnly });

export const setLoading = (loading) => ({ type: SET_LOADING, payload: loading });

export const setRefresh = (refresh) => ({ type: SET_REFRESH, payload: refresh });

export const setConsentsError = (consentsError) => ({
  type: SET_CONSENTS_ERROR,
  payload: consentsError
});

export const setConsentElementsError = (consentElementsError) => ({
  type: SET_CONSENT_ELEMENTS_ERROR,
  payload: consentElementsError
});

export const setDuplicateConsentId = (id) => ({
  type: SET_DUPLICATE_CONSENT_ID,
  payload: id
});
